import { HTMLAttributes } from "react";

export interface MDSSidePanelHeaderProps extends HTMLAttributes<HTMLDivElement> {
  backgroundColor?: string;
  bottomBorderColor?: string;
  isDisabled?: boolean;
}

export enum MDSSidePanelHeaderSlotName {
  Heading = "heading",
  Actions = "actions",
}
